import { BasicStoreFragment, useGetStoresQuery } from 'drycut-graphql';
import { Select } from 'ui-components';
import { useCheckoutStore } from '../checkoutStore';

export function SalonSelect(): React.ReactElement {
  const { data } = useGetStoresQuery();
  const setSelectedStore = useCheckoutStore((state) => state.setSelectedStore);
  const selectedStore = useCheckoutStore((state) => state.selectedStore);

  const stores = data?.stores?.nodes || [];
  const validStores = stores.filter((node): node is BasicStoreFragment => Boolean(node));

  const options = validStores.map((store) => ({
    id: store.id,
    label: store.name,
    value: store.slug,
  }));

  return (
    <Select
      options={options}
      selected={options.find((option) => option.value === selectedStore?.slug)}
      onChange={(option) => setSelectedStore(option.value)}
      prompt="Salon auswählen"
    />
  );
}
